document.addEventListener('DOMContentLoaded', () => {
  const contentful = require('contentful');
  const lazySizes = require('lazysizes');
  const SPACE_ID = 'te7w479p763y';
  const ACCESS_TOKEN = 'FEIsFFwmX2tW-zEtqr2-pxJS0PTpzqXRqS9jp9YNhHQ';
  const maturityTable = document.getElementById('xitavo-rm');
  const downloadSvgIcon = `<svg viewBox="0 0 1 1" class="iconography" size="xxs" color="green"><use xlink:href="../assets/icons/icons.svg#download-arrow"></use></svg>`;
  const client = contentful.createClient({
    space: SPACE_ID,
    accessToken: ACCESS_TOKEN
  });

  function convertKeyToName(key) {
    return key
      .match(/([A-Z]?[^A-Z]*)/g)
      .slice(0, -1)
      .join(' ');
  }

  function buildTableHtml(tableRows) {
    const finalRows = [];
    tableRows.forEach(tableRow => {
      finalRows.push(`
      <tr>
        <td>${convertKeyToName(tableRow[0])}</td>
        <td>${tableRow[1]}</td>
      </tr>
    `);
    });
    return finalRows.join('\n');
  }

  function renderTables(tableEntries) {
    const tableBuild = [];
    tableEntries.forEach(tableEntry => {
      const allFields = tableEntry.fields;
      const tablePDF = tableEntry.fields.profileSheet.fields.file.url;
      const tableTitle = Object.keys(allFields)
        .slice(0, 2)
        .reduce((result, key) => {
          result[key] = allFields[key];
          return result;
        }, {});
      const allContent = Object.entries(allFields);
      const tableRows = allContent.slice(2);
      const pdfFile = tableRows.pop();
      const builtTable = buildTableHtml(tableRows);

      tableBuild.push(`
        <div class="col-12 md:col-6 mb-2 ${tableRows[0][1] >= 1 ? 'table__hide' : ''}" id="${
        tableRows[0][1]
      }" tableVarieties>
          <table class="table table__yields table__maturity">
          <thead>
          <th class="bg-green color-white va-middle" width="70%"><span class="pr-2 uppercase">${tableTitle.name}</span>
          ${tableTitle.isNew ? '<span class="is-new type-xs font-normal color-black">NEW</span></th>' : ''}
          <th class="bg-green color-white align-center" width="30%">
            <div class="bg-green-dark download-logo enlist-logo items-center justify-center type-sm">
              RM ${tableRows[0][1]}
              <img src="../assets/images/enlist-e3-small.png">
            </div></th>
          </thead>
          <tbody>
          <tr>
            <td colspan="2">
              <div class="mt-2 mb-2 pdf-download">
                <span class="download__icon">${downloadSvgIcon}</span>
                <a href="${tablePDF}" class="type-sm font-normal type__downloads download__link">
                  Xitavo Profile Sheet ${tableEntry.fields.name} (PDF)
                </a>
              </div>
            </td>
          </tr>
          <tr>
          </tr>
          ${builtTable}
          </tbody>
        </table>
        </div>
      `);
    });
    return tableBuild.join('\n');
  }

  if (maturityTable) {
    client
      .getEntries({
        content_type: 'xitavoVarieties',
        order: 'fields.relativeMaturity,fields.name'
      })
      .then(response => {
        const allEntries = response.items;
        maturityTable.innerHTML = renderTables(allEntries);
      })
      .then(() => {
        const varietiesSelection = document.getElementById('maturity-group-select');
        const varietiesTable = document.querySelectorAll('[tableVarieties]');

        if (varietiesSelection) {
          const maturityGroups = varietiesSelection.querySelectorAll('.maturity-groups__nav--item');
          maturityGroups.forEach(group => {
            group.addEventListener('click', e => {
              $(maturityGroups).removeAttr('selected');
              const selection = e.target;
              const selectedGroup = selection.getAttribute('data-maturity-group');
              selection.setAttribute('selected', '');
              varietiesTable.forEach(variety => {
                const relativeMaturity = variety.id.slice(0, 1);
                if (relativeMaturity !== selectedGroup && !variety.className.includes('table__hide')) {
                  variety.classList.add('table__hide');
                }
                if (relativeMaturity === selectedGroup) {
                  variety.classList.remove('table__hide');
                }
              });
            });
          });
        }
      });
  }
});
